var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_GradientLayer = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_CanvasLayer(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "GradientLayer",
        options: {
            resolution: 3,
            source_type: 'GradientImageCanvasSource'
        }
    });
};
OCS.Viewer.Classes.GradientLayer = OCS.Viewer.Functions.define_GradientLayer();
